module.exports = __webpack_public_path__ + "assets/media/drift_login_foreground.ed3ebe99.svg";